import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                布丁漫画
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              最新最全的韩漫官网，提供免费在线韩国漫画阅读，官方源更新保证速度与质量，是获取一手韩漫资讯的权威站点。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              漫画分类
            </h4>
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.filter((c) => c.key !== 'all').map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="px-2.5 py-1 bg-background-800/50 text-background-300 rounded-md text-xs hover:bg-background-700 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  全部分类
                </Link>
              </li>
              <li>
                <Link
                  to="/category/恋爱"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  热门恋爱漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/category/奇幻"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  热门奇幻漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系与声明
            </h4>
            <ul className="space-y-2">
              <li className="text-sm text-background-400">
                <i className="ri-mail-line mr-2"></i>
                contact@budingmanhua.com
              </li>
              <li className="text-sm text-background-400">
                <i className="ri-shield-check-line mr-2"></i>
                本站所有漫画均来自官方授权
              </li>
              <li className="text-sm text-background-400">
                <i className="ri-copyright-line mr-2"></i>
                请支持正版漫画
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 布丁漫画 BudingManhua.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer"
            >
              服务条款
            </a>
            <a
              href="#"
              className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer"
              rel="nofollow"
            >
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}